<template>
  <div>
    <header>
      <Header :noAuth="noAuth" msg="Header" />
      <div class="searchbar">
        <div class="container">
          <CityDistrictSelector
            :initialCity="cityFilter"
            :initialDistrict="districtFilter"
            :isGpsActive="isGpsActive"
            :parentPermission="locationPermission"
            :parentIsLocating="isLocating"
            :shopAddresses="allShopAddresses"
            @change="onAddressChange"
            @gps-search="onGpsSearch"
          />
        </div>  
      </div>
      <!-- 定位權限說明按鈕（當拒絕且未顯示說明時顯示） -->
        <div v-if="locationPermission === 'denied' && !showGeolocationGuide" class="geolocation-alert-inline">
          <span>尚未定位，點擊查看</span>
            <button @click="showGeolocationGuide = true" class="btn-show-guide-link">
              如何開啟定位
            </button>
        </div>
    </header>

    <!-- 定位權限說明（當拒絕時顯示） -->
    <GeolocationGuide
      v-if="showGeolocationGuide"
      @close="showGeolocationGuide = false"
      @retry-success="handleRetrySuccess"
      @retry-failed="handleRetryFailed"
      @use-manual-selection="handleUseManualSelection"
    />

    <!-- 視圖切換按鈕 -->
    <div v-if="showViewMode" class="view-mode-toggle">
      <div class="container">
        <div class="toggle-buttons">
          <button
            :class="['toggle-btn', viewMode === 'map' ? 'active' : '']"
            @click="viewMode = 'map'"
          >
            <span class="icon-map"></span>
            地圖
          </button>
          <button
            :class="['toggle-btn', viewMode === 'list' ? 'active' : '']"
            @click="viewMode = 'list'"
          >
            <span class="icon-list"></span>
            列表
          </button>
        </div>
      </div>
    </div>

    <main>
      <Banners />
      <!-- <div class="banner owl-carousel owl-theme">
        <div class="item">
          <a href="javascript:">
            <img src="images/banner1.jpg" />
          </a>
        </div>
        <div class="item">
          <a href="javascript:">
            <img src="images/banner1.jpg" />
          </a>
        </div>
      </div> -->

      <nav class="tabs store" :style="{ top: showViewMode ? '96px' : '39px' }">
        <div class="container">
          <a
            href="javascript:"
            v-on:click="selectedCategory = 'all'"
            :class="[selectedCategory === 'all' ? 'current' : '']"
            >全部</a
          >
          <a
            href="javascript:"
            v-on:click="selectedCategory = 'history'"
            :class="[selectedCategory === 'history' ? 'current' : '']"
            >曾點過</a
          >
        </div>
      </nav>

      <div v-if="loading" class="loading_area flex_center">
        <div class="loader"></div>
        <div>loading..</div>
      </div>

      <div
        v-if="
          !shops || !shops[selectedCategory] || !shops[selectedCategory].length
        "
        class="page_notfound container flex_center flex_wrap"
      >
        <section>
          <div class="icon-notfound"></div>
          <div>
            <b>{{inputAddr ? '此區域目前沒有店家，請選擇其他地區' : '請選擇區域開始搜尋店家'}}</b>
          </div>
          <!--<div>找不到符合的店家</div>-->
        </section>
      </div>

      <!-- 地圖檢視 -->
      <!-- 優化：v-if 延遲載入（第一次點擊才創建）+ v-show 控制顯示（創建後不銷毀） -->
      <ShopMap
        v-if="mapActivated"
        v-show="shops && shops[selectedCategory] && shops[selectedCategory].length && viewMode === 'map'"
        :shops="filteredShops"
        :center="districtCenter"
        :zoom="mapZoom"
        @open-shop="openShop"
        @shop-selected="onShopSelected"
      />

      <!-- 列表檢視 -->
      <div v-show="shops && shops[selectedCategory] && shops[selectedCategory].length && viewMode === 'list'" class="storelist container flex_top flex_wrap">
        <div v-if="!filteredShops || !filteredShops.length" class="no-shops-message-list">
          <div class="icon-notfound"></div>
          <div class="message-text">
            <b>{{ inputAddr ? '此區域目前沒有店家，請選擇其他地區' : '請選擇區域開始搜尋店家' }}</b>
          </div>
        </div>
        <a
          v-for="(shop, index) in filteredShops"
          :key="index"
          class="flex_top flex_wrap"
          v-on:click="openShop(shop.id)"
        >
          <div class="cover">
            <img :src="shop.image ? shop.image : defaultImage" />
            <div v-if="!shop.isEnabled" class="cover_mask flex_center">
              暫不供應
            </div>
            <!-- 暫不供應的圖片加遮罩 -->

             <!-- <time :class="[shop.isEnabled ? '' : 'visible_hide']">
              <b>{{ shop.waitingHumanTime }}</b
              >{{ shop.waitingHumanUnit }}
            </time> -->
          </div>
          <div class="info">
            <div class="name">
              {{ shop.name }}
              <span v-show="isGpsSearchActive" class="km"
                >({{
                  (shop.distance !== null && shop.distance !== undefined) ? shop.distance.toFixed(2) + " km" : ""
                }})</span
              >
            </div>
            <div class="add">{{ shop.address }}</div>
          </div>
          <div class="focus">
            <div class="comment">
              <!-- <i class="icon-star"></i> 4.5 -->
            </div>

            <div :class="['status', shop.isEnabled ? '' : 'stop-open']">
              {{ shop.isEnabled ? "" : "暫不供應" }}
            </div>
          </div>
          <div class="iconbar">
            <div class="pick">
              <i v-if="shop.isDelivery" class="icon_delivery">送</i>
              <i v-if="shop.isTakeout" class="icon_self">自</i>
              <i v-if="shop.isEatIn" class="icon_inside">內</i>
            </div>
            <div class="pay">
              <i
                v-if="shop.isMobilePayment && shop.payMethods.linepay"
                class="icon_linepay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.googlepay"
                class="icon_googlepay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.applepay"
                class="icon_applepay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.credit"
                class="icon_creditcard"
              ></i>
               <i
                v-if="shop.isMobilePayment && shop.payMethods.easywallet"
                class="icon_easywallet"
              ></i>
               <i
                v-if="shop.isMobilePayment && shop.payMethods.taiwanpay"
                class="icon_taiwanpay"
              ></i>
                <i
                v-if="shop.isMobilePayment && shop.payMethods.jkopay"
                class="icon_jkopay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.icashpay"
                class="icon_icash"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.pxpay"
                class="icon_pxpay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.pxpayplus"
                class="icon_pxpay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.pluspay"
                class="icon_pluspay"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.twqr"
                class="icon_twqr"
              ></i>
              <i
                v-if="shop.isMobilePayment && shop.payMethods.aftee"
                class="icon_aftee"
              ></i>
              <i v-if="shop.isCash" class="icon_cash"></i>
            </div>
          </div>
        </a>
      </div>
      <!-- END .storelist -->
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Banners from "@/components/Banners.vue";
import CityDistrictSelector from "@/components/CityDistrictSelector.vue";
import GeolocationGuide from "@/components/GeolocationGuide.vue";
import ShopMap from "@/components/ShopMap.vue";
import { Base64 } from "js-base64";
import { authService } from "@/services/auth";
import apis from "@/services/apis";
import moment from "moment";
import { mockShops } from "@/data/mockShops";
import shopFilterMixin from '@/mixins/shopFilterMixin';
import geolocationMixin from "@/mixins/geolocationMixin";

import Vue from "vue";
Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

// var countries = [
//   { label: "United Kingdom", value: "UK", group: "North America" },
//   { label: "United States", value: "US", group: "North America" },
//   { label: "Uzbekistan", value: "UZ", group: "Asia" }
// ];

export default {
  name: "Delivery",
  components: {
    Header,
    Banners,
    CityDistrictSelector,
    GeolocationGuide,
    ShopMap
  },
  mixins: [shopFilterMixin, geolocationMixin],
  data() {
    return {
      loading: false,
      showViewMode: false,
      defaultImage: GLOBAL_DEFAULT_SHOP_IMG,
      selectedCategory: "all",
      shops: {
        all: [],
        history: []
      },
      inputAddr: "",
      mapZoom: 13,
      cityFilter: "",
      districtFilter: "",
      selectedDistrictCenter: null, // 儲存從 CityDistrictSelector 傳來的行政區中心經緯度
      viewMode: 'list', // 'map': 地圖檢視, 'list': 列表檢視
      mapActivated: false, // 用於延遲載入地圖（第一次點擊才創建）
      isGpsSearchActive: false, // 追蹤是否為 GPS 搜尋觸發
    };
  },
  computed: {
    userId() {
      return localStorage.getItem("lineUserId");
    },
    cachedAddress() {
      console.log("check addr " + localStorage.getItem("address"));
      if (!localStorage.getItem("address")) return {};
      else {
        let addrObj = JSON.parse(
          Base64.decode(localStorage.getItem("address"))
        );
        console.log('the addr is ' + JSON.stringify(addrObj));
        if (addrObj.placeId) return addrObj;
        else return null;
      }
    },
    noAuth() {
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        return "true";
      }
      return "false";
    },
    allShopAddresses() {
      return (this.shops.all || []).map(s => s.address).filter(Boolean);
    },
    filteredShops() {
      // 根據 cityFilter 和 districtFilter 過濾當前分類的商店
      const currentShops = this.shops[this.selectedCategory] || [];

      // 如果是 GPS 搜尋觸發，使用 applyGeolocationFilter
      if (this.isGpsSearchActive && this.userCoords) {
        return this.applyGeolocationFilter(this.userCoords);
      }

      // 其他情況使用 applyMixedFilter
      const centerPoint = this.districtCenter;

      return this.applyMixedFilter(currentShops, {
        city: this.cityFilter,
        district: this.districtFilter,
        coords: this.userCoords || centerPoint,
        radius: (this.foodType === 'AllShops' || !this.cityFilter) ? 0 : this.filterRadius,
        limit: 0,
        mode: this.filterMode
      });
    },
    districtCenter() {
      // 使用從 CityDistrictSelector 傳來的行政區中心經緯度
      // gpsLocation 只用來移動地圖視野，不影響店家篩選
      if (this.selectedDistrictCenter && this.selectedDistrictCenter.lat && this.selectedDistrictCenter.lng) {
        return this.selectedDistrictCenter;
      }

      // 計算商店的中心點作為預設值
      return this.calculateShopsCenter();
    }
  },
  methods: {
     applyGeolocationFilter(coords) {
      console.log('Delivery: Applying geolocation filter:', coords);

      // 啟用 GPS 搜尋模式（無論是手動還是自動定位）
      this.isGpsSearchActive = true;

      // 使用 mixin 的距離篩選方法
      const nearbyShops = this.filterByDistance(coords, {
        limit: 60,        // 顯示前 60 間最近的店家
        maxRadius: 0      // 關閉半徑過濾，顯示最近的
      });

      console.log(`Delivery: Found ${nearbyShops.length} nearby shops`);

      // 更新地圖中心點
      if (this.$refs.shopMap) {
        this.$refs.shopMap.setCenter(coords);
      }

      return nearbyShops;
    },
    calculateShopsCenter() {
      // 取得當前分類的商店列表
      const currentShops = this.shops[this.selectedCategory] || [];

      if (currentShops.length === 0) {
        // 沒有商店時，返回台北市中心
        return { lat: 25.0330, lng: 121.5654 };
      }

      let filteredShops = currentShops;

      // 逐步過濾 1: 縣市
      if (this.cityFilter) {
        filteredShops = filteredShops.filter(shop =>
          shop.address && shop.address.includes(this.cityFilter)
        );
      }

      // 逐步過濾 2: 行政區
      if (this.districtFilter) {
        filteredShops = filteredShops.filter(shop =>
          shop.address && shop.address.includes(this.districtFilter)
        );
      }

      // 過濾出有經緯度的商店
      const shopsWithCoords = filteredShops.filter(shop => shop.lat && shop.lng);

      if (shopsWithCoords.length === 0) {
        // 若過濾後無座標，則嘗試對「過濾前」有座標的商店取平均（涵蓋切換回全部縣市的情境）
        const allShopsWithCoords = currentShops.filter(shop => shop.lat && shop.lng);
        if (allShopsWithCoords.length === 0) {
          return { lat: 25.0330, lng: 121.5654 };
        }
        
        const avgLat = allShopsWithCoords.reduce((sum, shop) => sum + parseFloat(shop.lat), 0) / allShopsWithCoords.length;
        const avgLng = allShopsWithCoords.reduce((sum, shop) => sum + parseFloat(shop.lng), 0) / allShopsWithCoords.length;
        return { lat: avgLat, lng: avgLng };
      }

      // 計算符合條件店家的平均經緯度
      const avgLat = shopsWithCoords.reduce((sum, shop) => sum + parseFloat(shop.lat), 0) / shopsWithCoords.length;
      const avgLng = shopsWithCoords.reduce((sum, shop) => sum + parseFloat(shop.lng), 0) / shopsWithCoords.length;

      return { lat: avgLat, lng: avgLng };
    },
    openShop(shopId) {
      this.$router.push({
        path: `/delivery/${shopId}`, query: this.$router.currentRoute.query
      })
    },
    onShopSelected(shop) {
      console.log('Selected shop:', shop);
      // 可以在這裡處理商店選擇事件
    },
    getUserId() {
      return localStorage.getItem("lineUserId");
    },
    onAddressChange(data) {
      // 當縣市或行政區改變時
      const { city, district, lat, lng } = data;

      // 清除 GPS 定位點（手動選擇地址時不再使用 GPS 位置）
      this.clearDistanceFilter();

      // 清除保存的地圖狀態（使用者主動更改篩選條件）
      localStorage.removeItem('mapState');

      // 停用 GPS 搜尋模式，切換為地址篩選模式
      this.isGpsSearchActive = false;
      this.filterMode = 'address';

      // 更新篩選條件
      this.cityFilter = city || "";
      this.districtFilter = district || "";

      // 儲存從 CityDistrictSelector 傳來的行政區中心經緯度
      if (lat && lng) {
        this.selectedDistrictCenter = { lat, lng };
      } else {
        this.selectedDistrictCenter = null;
      }

      // 保存到 localStorage，以便返回時恢復（包含經緯度）
      if (city || district) {
        localStorage.setItem('cityDistrictFilter', JSON.stringify({
          city: this.cityFilter,
          district: this.districtFilter,
          lat: lat || null,
          lng: lng || null
        }));
      } else {
        localStorage.removeItem('cityDistrictFilter');
      }

      if (city && district) {
        // 有選擇特定縣市和行政區
        this.inputAddr = `${city}${district}`;
        this.mapZoom = 14;
        // filteredShops 和 districtCenter 會自動根據 cityFilter 和 districtFilter 更新
      } else if (city && !district) {
        // 只選擇縣市，顯示該縣市所有店家
        this.inputAddr = city;
        this.mapZoom = 12;
        // filteredShops 會自動過濾
      } else {
        // 選擇「全部縣市」
        this.inputAddr = "";
        this.mapZoom = 11;
        // filteredShops 會返回所有店家
      }
    },
    onGpsSearch(data) {
      // 當使用 GPS 定位時
      const { lat, lng } = data;

      if (lat && lng) {
        const coords = { lat: parseFloat(lat), lng: parseFloat(lng) };
        this.mapZoom = 15;

        // 定位後清除選取的縣市行政區與快取
        this.cityFilter = "";
        this.districtFilter = "";
        this.selectedDistrictCenter = null;
        this.inputAddr = "";
        localStorage.removeItem('cityDistrictFilter');

        // 切換為距離篩選模式，觸發定位篩選與狀態更新
        this.filterMode = 'radius';
        this.updateGeolocation(coords);
      }
    },
    /**
     * 重新定位成功
     */
    handleRetrySuccess() {
      console.log('Retry geolocation success');
      this.showGeolocationGuide = false;
      this.showCityDistrictSelector = false;
    },

    /**
     * 重新定位失敗
     */
    handleRetryFailed(error) {
      console.error('Retry geolocation failed:', error);
      // 保持顯示縣市選單
      this.showCityDistrictSelector = true;
    },

    /**
     * 使用者選擇手動選擇縣市
     */
    handleUseManualSelection() {
      console.log('User chose manual selection');
      this.showGeolocationGuide = false;
      this.showCityDistrictSelector = true;
    },
    getCacheAddress() {
      if (!localStorage.getItem("address")) return {};
      else {
        let addrObj = JSON.parse(
          Base64.decode(localStorage.getItem("address"))
        );
        if (addrObj.placeId) return addrObj;
        else return null;
      }
    },
    setAddressInput(addrObj) {
      if (!addrObj) return;

      if (addrObj.mainText && addrObj.secondaryText) {
        this.inputAddr = `${addrObj.mainText ? addrObj.mainText : ""}${
          addrObj.aptSuiteFloor ? " " + addrObj.aptSuiteFloor : ""
        }`;
      } else if (addrObj.address) {
        this.inputAddr = addrObj.address;
      }

      // 縣市和行政區篩選條件會從 localStorage 的 cityDistrictFilter 恢復
    },
    getAddress() {
      let self = this;

      // 先取得所有店家
      self.getPortalShops();

      if (!self.userId) return;

      return apis
        .getUserProfile(self.userId)
        .then(function(responses) {
          if (responses && responses.address) {
            console.log('cache addr ' + JSON.stringify(responses));
            localStorage.setItem(
              "address",
              Base64.encode(
                JSON.stringify({
                  address: responses.address,
                  mainText: responses.mainText,
                  secondaryText: responses.secondaryText,
                  placeId: responses.placeId,
                  aptSuiteFloor: responses.aptSuiteFloor
                })
              )
            );
            self.setAddressInput(responses);
          }
        })
        .catch(function(e) {
          console.log("fetch user failed " + e.stack);
        });
    },
    getHistoryShops(userId) {
      let self = this;
      return fetch(
        `${process.env.VUE_APP_APIHOST}/apis/history-shops?user_id=${userId}&p=${self.$router.currentRoute.query.p}`
      )
        .then(res => res.json())
        .then(function(responses) {
          let hmap = {};

          for (let i = 0; i < responses.length; ++i) {
            if (responses[i]) hmap[responses[i].shopId] = true;
          }
          self.shops.history = [];
          for (let j = 0; j < self.shops.all.length; ++j) {
            if (self.shops.all[j].id && hmap[self.shops.all[j].id.toString()])
              self.shops.history.push(self.shops.all[j]);
          }
        })
        .catch(function(e) {
          console.log("fetch user failed " + e.stack);
        });
    },
    getPortalShops() {
      let self = this;
      self.loading = true;

      let options = { is_delivery: true };
      if (this.deliveryFilter) {
        options.deliveryFilter = this.deliveryFilter;
      }

      // 使用假資料進行測試
      if (process.env.VUE_APP_USE_MOCK_DATA === 'true') {
        setTimeout(() => {
          self.processMockShops(mockShops);
          self.loading = false;
        }, 500);
        return Promise.resolve();
      }

      return apis
        .getPortalShops(this.$router.currentRoute.query.p, "catering", options)
        .then((response) => {
          let shops = [];
          for (let i = 0; i < response.length; ++i) {
            if (!response[i]) continue;

            // 只保留支援外送的店家
            if (response[i].isDelivery !== 1) continue;

            response[i].waitingTime = parseInt(response[i].deliveryWaitingTime ? response[i].deliveryWaitingTime : response[i].waitingTime, 10);
            moment.relativeTimeThreshold("m"); //=> 22 (current value)
            moment.relativeTimeThreshold("m", 180); // (set new value to 24 (三小時內統一都用分鐘顯示)
            moment.relativeTimeThreshold("h"); //=> 22 (current value)
            moment.relativeTimeThreshold("h", 24); // (set new value to 24
            let waitingStr = moment
              .duration(response[i].waitingTime + 30, "minutes")
              .locale("zh-TW")
              .humanize();
            let ss = waitingStr.split(" ");
            response[i].waitingHumanTime = ss[0];
            response[i].waitingHumanUnit = ss[1];

            response[i].payMethods = {
              linepay: true,
              applepay: true,
              googlepay: true,
              credit: true,
              easywallet: false,
              jkopay: false,
              taiwanpay: false
            };
            if (
              response[i].isMobilePayment &&
              response[i].paymentOptions &&
              response[i].paymentOptions.methods
            ) {
              // 有限制顯示的支付方式
              response[i].payMethods = {};

              for (
                let p = 0;
                p < response[i].paymentOptions.methods.length;
                ++p
              ) {
                response[i].payMethods[
                  response[i].paymentOptions.methods[p]
                ] = true;
              }
            }
            shops.push(response[i]);
          }
          self.shops.all = shops;
          self.getHistoryShops(self.getUserId());
          self.loading = false;
        })
        .catch((e) => {
          console.log("get portal shops failed " + e.stack);
          self.loading = false;
        });
    },
    processMockShops(shopsData) {
      // 處理假資料
      let shops = [];
      for (let i = 0; i < shopsData.length; ++i) {
        if (!shopsData[i]) continue;

        // 只保留支援外送的店家
        if (shopsData[i].isDelivery !== 1) continue;

        shopsData[i].waitingTime = parseInt(shopsData[i].deliveryWaitingTime ? shopsData[i].deliveryWaitingTime : shopsData[i].waitingTime, 10);
        moment.relativeTimeThreshold("m", 180);
        moment.relativeTimeThreshold("h", 24);
        let waitingStr = moment
          .duration(shopsData[i].waitingTime + 30, "minutes")
          .locale("zh-TW")
          .humanize();
        let ss = waitingStr.split(" ");
        shopsData[i].waitingHumanTime = ss[0];
        shopsData[i].waitingHumanUnit = ss[1];

        shopsData[i].payMethods = {
          linepay: true,
          applepay: true,
          googlepay: true,
          credit: true,
          easywallet: false,
          jkopay: false,
          taiwanpay: false
        };

        if (
          shopsData[i].isMobilePayment &&
          shopsData[i].paymentOptions &&
          shopsData[i].paymentOptions.methods
        ) {
          shopsData[i].payMethods = {};
          for (let p = 0; p < shopsData[i].paymentOptions.methods.length; ++p) {
            shopsData[i].payMethods[shopsData[i].paymentOptions.methods[p]] = true;
          }
        }
        shops.push(shopsData[i]);
      }
      this.shops.all = shops;
      this.getHistoryShops(this.getUserId());
    }
  },
  mounted() {

    // 恢復縣市行政區篩選條件
    const savedFilters = localStorage.getItem('cityDistrictFilter');
    if (savedFilters) {
      try {
        const filters = JSON.parse(savedFilters);
        this.filterMode = 'address';
        this.cityFilter = filters.city || '';
        this.districtFilter = filters.district || '';

        // 恢復行政區中心經緯度
        if (filters.lat && filters.lng) {
          this.selectedDistrictCenter = { lat: filters.lat, lng: filters.lng };
        }

        // 更新顯示的地址
        if (filters.city && filters.district) {
          this.inputAddr = `${filters.city}${filters.district}`;
          this.mapZoom = 14;
        } else if (filters.city) {
          this.inputAddr = filters.city;
          this.mapZoom = 12;
        }
      } catch (e) {
        console.error('Failed to restore filters:', e);
      }
    } else {
      // 如果沒有縣市篩選，嘗試恢復 GPS 定位（距離篩選模式）
      this.filterMode = 'radius';
      this.autoGeolocation()
      // const savedUserLocation = this.getUserLocation();
      // if (savedUserLocation) {
      //   this.applyGeolocationFilter(savedUserLocation);
      // } 
    }

    // 恢復視圖模式
    // const savedViewMode = localStorage.getItem('viewMode');
    // if (savedViewMode && (savedViewMode === 'map' || savedViewMode === 'list')) {
    //   this.viewMode = savedViewMode;
    // }

    // 登入後才執行
    this.subscription = authService.getUserId().subscribe(userId => {
      // 訂閱到 userId 後，如果有 cachedAddress，設置地址顯示和過濾條件
      if (this.cachedAddress) {
        this.setAddressInput(this.cachedAddress);
      }
    });

    // 總是調用 getAddress()，它會負責獲取店家和設置地址
    this.getAddress();
  },
  props: {
    deliveryFilter: String
  },
  watch: {
    viewMode(newValue) {
      // 當 viewMode 改變時，保存到 localStorage
      localStorage.setItem('viewMode', newValue);
      
      // 當切換到地圖模式時，啟用地圖（第一次才會創建）
      if (newValue === 'map' && !this.mapActivated) {
        this.mapActivated = true;
      }
    }
  },
  beforeDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }
};
</script>
<style scoped>
.banner {
  width: 1200px;
  max-width: 100%;
  margin: 10px auto 20px auto;
}
/*.searchbar .searchbar_box .loader { display: block; }*/

/* 列表視圖無店家提示 */
.no-shops-message-list {
  width: 100%;
  text-align: center;
  padding: 60px 30px;
}

.no-shops-message-list .icon-notfound {
  margin-bottom: 15px;
}

.no-shops-message-list .message-text {
  font-size: 16px;
  color: #333;
}

.no-shops-message-list .message-text b {
  font-weight: 600;
}

/* 視圖切換按鈕樣式 */
.view-mode-toggle {
  position: sticky;
  top: 39px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
  padding: 12px 0;
  z-index: 10;
}

.view-mode-toggle .toggle-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.view-mode-toggle .toggle-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border: 2px solid #ddd;
  background: #fff;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.view-mode-toggle .toggle-btn:hover {
  border-color: #999;
  color: #333;
}

.view-mode-toggle .toggle-btn.active {
  border-color: #4CAF50;
  background: #4CAF50;
  color: #fff;
}

.view-mode-toggle .toggle-btn .icon-map::before,
.view-mode-toggle .toggle-btn .icon-list::before {
  font-size: 16px;
}

/* 簡單的圖標樣式（如果沒有現成的圖標） */
.view-mode-toggle .toggle-btn .icon-map::before {
  content: '🗺️';
}

.view-mode-toggle .toggle-btn .icon-list::before {
  content: '📋';
}

/* 調整 nav.tabs 的固定位置，避免與視圖切換按鈕重疊 */
nav.tabs.store {
  top: 96px;
}

.geolocation-alert-inline {
  margin-top: 8px;
  font-size: 13px;
  color: #856404;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-show-guide-link {
  background: none;
  border: none;
  padding: 0;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 13px;
}
</style>
<style>
/* 確保 header 的 z-index 高於視圖切換按鈕 */
header {
  z-index: 20;
}

/* 確保下拉選單的 z-index 高於視圖切換按鈕 */
.searchbar .autocomplete {
  z-index: 100;
}

/* .searchbar .searchbar_box .loader {
  display: block;
}
.searchbar .autocomplete {
  height: auto;
} */
</style>
